import $ from 'jquery';

export default function Accordion (el) {
  var $accordionToggle = $(el);

  $accordionToggle.on('click', function (e) {
    var $currentToggle = $(e.target);
    $currentToggle.toggleClass('active');
    toggleAccordion($currentToggle.data('accordion'));
  });

  function toggleAccordion($accordionId) {
    $('#' + $accordionId).slideToggle('fast');
  }
}
